import { matchPath } from 'react-router-dom';
import { localeInPath, localizeRoutePath } from '../locale';
import {
  removeBrandPathFromRoute,
  removeSitePathFromRoute,
  siteTypesEnum,
} from '../index';
import findActiveRoutesGroup from '../findActiveRoutesGroup';
import { RouteInstance } from '../../types';

export interface FindActiveRouteProps {
  path: string;
  isPreview: boolean;
  siteType: keyof ReturnType<typeof siteTypesEnum>;
  audienceType: string;
  routes: Record<string, RouteInstance[]>;
  singleSiteMode: boolean;
  brandSubPath?: string;
  newPaymentJourneyEnabled?: boolean;
}

export function isLandingGroupPathComplete(
  path: string,
  routePath: string,
): boolean {
  if (!localeInPath(path)) {
    return true;
  }

  const pathSegments = path.split('/').filter(Boolean).length;
  const requiredSegments = routePath.split('/').filter(Boolean).length;

  return pathSegments >= requiredSegments;
}

export default function findActiveRoute(props: FindActiveRouteProps) {
  const {
    path,
    isPreview,
    siteType,
    audienceType,
    routes,
    singleSiteMode,
    brandSubPath,
    newPaymentJourneyEnabled,
  } = props;

  const routesGroup = findActiveRoutesGroup({
    isPreview,
    siteType,
    audienceType,
    routes,
    newPaymentJourneyEnabled,
  });

  return routesGroup.find((route: RouteInstance) => {
    const currentRoute = {
      path: localizeRoutePath(route.path),
      exact: route.exact,
    };

    if (singleSiteMode) {
      currentRoute.path = removeSitePathFromRoute(currentRoute.path);
    }

    if (!brandSubPath) {
      currentRoute.path = removeBrandPathFromRoute(currentRoute.path);
    }

    if (
      currentRoute.path.includes(':landingGroupPath') &&
      matchPath(path, currentRoute)
    ) {
      return isLandingGroupPathComplete(path, currentRoute.path);
    }

    return matchPath(path, currentRoute);
  });
}
